import React, { ReactElement } from 'react';
import TableSortLabelInternal from '@mui/material/TableSortLabel';
import SortIcon from '../../icons/sort-icon';
import useStylesTableSortLabel from './table-sort-label.styles';

const TableSortLabel: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isActive,
    withNoLabel,
    sortType,
    onClick,
    children,
  } = props;

  const { classes } = useStylesTableSortLabel();

  return (
    <TableSortLabelInternal
      active={isActive}
      direction={sortType}
      classes={{
        root: classes.tableSortLabelFilter,
        active: classes.tableSortLabelFilterActive,
      }}
      onClick={onClick}
      IconComponent={SortIcon}
    >
      {!withNoLabel ? children : ''}
    </TableSortLabelInternal>
  );
});

export default TableSortLabel;
